import type { HTMLAttributes, ReactNode } from "react";

type CardElement = "article" | "section" | "div";

export interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: CardElement;
  children: ReactNode;
  elevation?: "flat" | "raised";
  tone?: "default" | "accent";
}

export function Card({
  as: Element = "section",
  children,
  className,
  elevation = "flat",
  tone = "default",
  ...props
}: CardProps) {
  return (
    <Element
      {...props}
      className={["ui-card", className].filter(Boolean).join(" ")}
      data-elevation={elevation}
      data-tone={tone}
    >
      {children}
    </Element>
  );
}

export interface CardHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  headingLevel?: 2 | 3 | 4;
}

export function CardHeader({
  title,
  description,
  action,
  headingLevel = 2,
  className,
  ...props
}: CardHeaderProps) {
  const Heading = `h${headingLevel}` as const;

  return (
    <div {...props} className={["ui-card__header", className].filter(Boolean).join(" ")}>
      <div>
        <Heading className="ui-card__title">{title}</Heading>
        {description ? <p className="ui-card__description">{description}</p> : null}
      </div>
      {action ? <div className="ui-cluster">{action}</div> : null}
    </div>
  );
}
